import { z } from "zod";

export const isMonthValid = (month: string) => {
  const monthAsNumber = parseInt(month, 10);
  return monthAsNumber >= 1 && monthAsNumber <= 12;
};

export const isYearValid = (
  year: string,
  minYear?: number,
  maxYear?: number
) => {
  const yearAsNumber = parseInt(year, 10);

  return yearAsNumber >= (minYear ?? 1000) && yearAsNumber <= (maxYear ?? 9999);
};

const currentYear = new Date().getFullYear();

export const expirationDateSchema = z.object({
  month: z.string().length(2).refine(isMonthValid, {
    message: "Veuillez entrer un mois valide",
  }),
  year: z
    .string()
    .length(4)
    .refine((year) => isYearValid(year, currentYear, currentYear + 50), {
      message: "Veuillez entrer une année valide",
    }),
});
